var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3151,
    cy: 24.3151,
    r: 24.3151,
    fill: "#2F80ED",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 24.439H27.75C24.6375 24.439 23.0625 22.6765 23.0625 19.189V15.6015C23.0625 14.3265 23.2125 12.5015 24.5375 11.5015C25.65 10.6765 27.25 10.614 29.6125 11.3015C32.7125 12.2015 35.3 14.789 36.2 17.889C36.8875 20.239 36.825 21.8515 36 22.9515C35 24.289 33.175 24.439 31.9 24.439ZM26.85 12.7015C26.3375 12.7015 25.9375 12.8015 25.675 13.0015C25.1875 13.364 24.95 14.214 24.95 15.6015V19.2015C24.95 22.0015 26.025 22.5765 27.7625 22.5765H31.9125C33.2875 22.5765 34.1375 22.339 34.5125 21.8515C34.95 21.2765 34.9125 20.1265 34.425 18.439C33.7 15.9765 31.575 13.839 29.1125 13.1265C28.1875 12.839 27.4375 12.7015 26.85 12.7015Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8458 36.9364C22.1833 36.9364 21.5083 36.8864 20.8333 36.7739C15.7208 35.9489 11.5583 31.7989 10.7333 26.6864C9.67078 20.1114 13.9083 13.9114 20.3958 12.5864C20.9083 12.4864 21.3958 12.8114 21.5083 13.3114C21.6083 13.8239 21.2833 14.3114 20.7833 14.4239C15.2958 15.5489 11.6958 20.7989 12.6083 26.3864C13.3083 30.7114 16.8208 34.2239 21.1458 34.9239C26.7583 35.8239 31.9958 32.2114 33.1083 26.6989C33.2083 26.1864 33.7083 25.8614 34.2083 25.9614C34.7208 26.0614 35.0458 26.5614 34.9458 27.0614C33.7583 32.8989 28.6583 36.9364 22.8458 36.9364Z",
    fill: "#3B82F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6281 23.0648L25.25 23.0646L24 17.4385L25.2531 12.4398C26.7531 11.9398 30.6698 12.4387 32.7531 13.6887L35.2531 19.3148L34.6281 23.0648Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIcon);
export default __webpack_public_path__ + "static/media/pie_chart_icon.f72dc6ca5c69bdff42335eaddb2131bd.svg";
export { ForwardRef as ReactComponent };